/**
 * Single source of truth for "is the signed-in user an admin?" — backed by
 * `GET /me` via TanStack Query (`["me"]`). Used by the AppShell nav (to show
 * the Admin link) and the `RequireAdmin` route guard.
 *
 * This is UX only. The real gate is server-side `require_admin` on every
 * `/admin/*` endpoint, so a forged client value just yields 403s.
 */

import { useQuery } from "@tanstack/react-query";

import { getMe } from "@/features/admin/lib/adminApi";

export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    staleTime: 5 * 60 * 1000, // identity rarely changes; avoid refetch churn
  });
  return { isAdmin: data?.isAdmin ?? false, isLoading };
}
